import { Purchases } from '@revenuecat/purchases-js'

const RC_API_KEY = import.meta.env.VITE_REVENUECAT_WEB_API_KEY

let instance: Purchases | null = null

export function configurePurchases(appUserId: string): Purchases {
  if (instance && Purchases.isConfigured()) {
    return instance
  }

  if (!RC_API_KEY) {
    throw new Error('Missing VITE_REVENUECAT_WEB_API_KEY environment variable')
  }

  instance = Purchases.configure({
    apiKey: RC_API_KEY,
    appUserId,
  })

  return instance
}
